import ActivitiesListItem from '../activities/ActivitiesListItem';
import ChronologyListItem from '../chronology/ChronologyListItem';
import CommercialCampaignsListItem from '../commercialcampaigns/CommercialCampaignsListItem';
import CommercialCampaignsRowsListItem from '../commercialcampaigns/commercialcampaigns-rows/CommercialCampaignsRowsListItem';
import CompaniesListItem from '../companies/CompaniesListItem';
import ContractsListItem from '../contracts/ContractsListItem';
import DemsListItem from '../dems/DemsListItem';
import ErpOrdersListItem from '../erp-orders/ErpOrdersListItem';
import ErpQuotationsListItem from '../erp-quotations/ErpQuotationsListItem';
import GroupsListItem from '../groups/GroupsListItem';
import ItemsListItem from '../items/ItemsListItem';
import MarketingActionsListItem from '../marketingactions/MarketingActionsListItem';
import MarketingActionsRowsListItem from '../marketingactions/marketingactions-rows/MarketingActionsRowsListItem';
import OpportunitiesListItem from '../opportunities/OpportunitiesListItem';
import OrdersListItem from '../orders/OrdersListItem';
import PeopleListItem from '../people/PeopleListItem';
import ProjectsListItem from '../projects/ProjectsListItem';
import TicketsListItem from '../tickets/TicketsListItem';
import UsersListItem from '../users/UsersListItem';
import WorkReportsListItem from '../workreports/WorkReportsListItem';

const listItems = {
	activities: ActivitiesListItem,
	chronology: ChronologyListItem,
	commercialcampaigns: CommercialCampaignsListItem,
	commercialcampaigns_rows: CommercialCampaignsRowsListItem,
	companies: CompaniesListItem,
	contracts: ContractsListItem,
	dems: DemsListItem,
	erp_orders: ErpOrdersListItem,
	erp_quotations: ErpQuotationsListItem,
	groups: GroupsListItem,
	items: ItemsListItem,
	marketingactions: MarketingActionsListItem,
	marketingactions_rows: MarketingActionsRowsListItem,
	opportunities: OpportunitiesListItem,
	orders: OrdersListItem,
	people: PeopleListItem,
	projects: ProjectsListItem,
	tickets: TicketsListItem,
	users: UsersListItem,
	workreports: WorkReportsListItem
};

export default listItems;
